import { useStore, useMedia } from "shared/hooks";

import { observer } from 'mobx-react';
import { PPDWidgetGroupSelectDropdown } from 'pages/profile-dashboard/components/PPDWidget/components/PPDWidgetGroupSelect/components/PPDWidgetGroupSelectDropdown';
import { PPDWidgetGroupSelectModal } from 'pages/profile-dashboard/components/PPDWidget/components/PPDWidgetGroupSelect/components/PPDWidgetGroupSelectModal';

type PPDWidgetGroupSelectProps = {
    items?: { id: string | number; name: string }[];
    value?: string | number | null;
    onChange?: (id: string | number) => void;
    activeTrigger?: boolean;
    onClickTrigger?: () => void;
    activeToggle?: boolean;
    onClickToggle?: () => void;
};

export const PPDWidgetGroupSelect = observer(({
    items = [],
    value = null,
    onChange = () => {},
    activeToggle = true,
    onClickToggle = () => {},
}: PPDWidgetGroupSelectProps) => {
    const store = useStore(() => ({
        isOpen: false,
    }));
    const { isMobileOrTablet } = useMedia();

    const current = items.find(g => g.id === value) || items[0];

    const handleSelect = (id: string | number) => {
        onChange(id);
        store.set("isOpen", false);
    };

    const handleToggle = () => {
        if (activeToggle) {store.toggle("isOpen")}
        onClickToggle();
    };

    return isMobileOrTablet ? (
        <PPDWidgetGroupSelectModal
            items={items}
            value={value}
            isOpen={store.isOpen}
            onToggle={handleToggle}
            onClose={() => store.set("isOpen", false)}
            onSelect={handleSelect}
            current={current}
        />
    ) : (
        <PPDWidgetGroupSelectDropdown
            items={items}
            value={value}
            isOpen={store.isOpen}
            onToggle={() => store.toggle("isOpen")}
            onClose={() => store.set("isOpen", false)}
            onSelect={handleSelect}
            current={current}
        />
    );
});
